import React, { useState, useCallback } from 'react';
import { Link } from 'react-router-dom';

const mobileLinks = [
  { label: 'Home', path: '/' },
  {
    label: "L'Organizzazione",
    path: '#!',
    submenu: [
      {
        title: 'Chi Siamo', links: [
          { label: 'Perché Giovani Democratici', path: '/perche-giovani-democratici' },
          { label: 'Chi Siamo', path: '/chi-siamo' },
          { label: 'Organizzazione', path: '/organizzazione' },
        ]
      },
      {
        title: 'Persone', links: [
          { label: 'Segreteria Nazionale', path: '/segreteria' },
          { label: 'Segretari Territoriali', path: '/segretari' },
          { label: 'Eletti', path: '/eletti' },
          { label: 'Rubrica Generale', path: '/persone' },
        ]
      },
      {
        title: 'Documenti', links: [
          { label: 'Tutti i Documenti', path: '/documenti' },
          { label: 'Trasparenza', path: '/trasparenza' },
        ]
      },
    ],
  },
  {
    label: 'Il Territorio',
    path: '#!',
    submenu: [
      {
        title: 'Territorio', links: [
          { label: 'Circoli', path: '/circoli' },
          { label: 'Federazioni Regionali', path: '/federazioni-regionali' },
          { label: 'Federazioni Provinciali', path: '/federazioni-provinciali' },
        ]
      },
      {
        title: 'Iniziative', links: [
          { label: 'Eventi', path: '/eventi' },
        ]
      },
    ],
  },
  {
    label: 'News & Media',
    path: '#!',
    submenu: [
      {
        title: 'Media', links: [
          { label: 'Notizie', path: '/notizie' },
          { label: 'Video', path: '/video' },
          { label: 'Podcast', path: '/podcast' },
          { label: 'Area Stampa', path: '/stampa' },
        ]
      },
    ],
  },
  { label: 'Contatti', path: '/contatti' },
];

const MobileMenu = ({ isOpen, onClose }) => {
  const [openSubmenu, setOpenSubmenu] = useState(null);

  const handleSubmenuToggle = useCallback((label) => {
    setOpenSubmenu((prev) => (prev === label ? null : label));
  }, []);

  const handleLinkClick = useCallback(() => {
    onClose();
    setOpenSubmenu(null);
  }, [onClose]);

  return (
    <div
      className={`mobile-menu${isOpen ? ' is-open' : ''}`}
      role="dialog"
      aria-label="Menu di navigazione"
    >
      <button className="mobile-menu__close" aria-label="Chiudi menu" onClick={onClose}>
        ×
      </button>
      <nav className="mobile-menu__nav">
        {mobileLinks.map((item) =>
          item.submenu ? (
            <React.Fragment key={item.label}>
              <a
                href="#!"
                className="mobile-menu__link"
                onClick={(e) => {
                  e.preventDefault();
                  handleSubmenuToggle(item.label);
                }}
              >
                {item.label} <span>›</span>
              </a>
              <div
                className={`mobile-menu__submenu${openSubmenu === item.label ? ' is-open' : ''
                  }`}
              >
                {item.submenu.map((group) => (
                  <div key={group.title} className="mobile-menu__section">
                    <div className="mobile-menu__section-title">
                      {group.title}
                    </div>
                    {group.links.map((link) => (
                      <Link
                        to={link.path}
                        className="mobile-menu__sublink"
                        key={link.path}
                        onClick={handleLinkClick}
                      >
                        {link.label}
                      </Link>
                    ))}
                  </div>
                ))}
              </div>
            </React.Fragment>
          ) : (
            <Link
              to={item.path}
              className="mobile-menu__link"
              key={item.path}
              onClick={handleLinkClick}
            >
              {item.label}
            </Link>
          )
        )}
      </nav>
      <div className="mobile-menu__cta">
        <Link to="/partecipa" className="btn btn--primary w-full" onClick={handleLinkClick}>
          Partecipa
        </Link>
        <Link to="/ricerca" className="btn btn--outline w-full" onClick={handleLinkClick}>
          Cerca nel sito
        </Link>
      </div>
    </div>
  );
};

export default MobileMenu;
